/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatePatient/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CreatePatient({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PatientAction/CreatePatient",
  isDisabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isDisabled
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 block={true}
 onClick={onClick}
 disabled={isDisabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create Patient"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}